export const installSequence=[
  {
    "id": "01",
    "title": "查看 Codex 助手发布状态",
    "text": "客户端安装包待发布。获取正式安装包后，先核对系统与架构要求，再按对应平台指引安装；Mac 按 PKG 提示安装到“应用程序”。"
  },
  {
    "id": "02",
    "title": "连接账户与模型",
    "text": "在助手内连接当前账户，确认人民币余额与当前任务使用的模型。涉及购买时，先确认报价与订单状态。"
  },
  {
    "id": "03",
    "title": "选择 Skills",
    "text": "最后根据自媒体创作、素材调研、数据整理或客户转化任务选择对应 Skill。"
  }
] as const;
export const downloads=[
  {
    "os": "WIN",
    "title": "Windows 配置助手",
    "desc": "适用 Windows 10/11 64 位系统",
    "config": "会提示备份、写入与恢复",
    "version": null,
    "bytes": null,
    "url": null
  },
  {
    "os": "MAC",
    "title": "macOS 配置助手",
    "desc": "适用 Apple Silicon（M 系列），macOS 14 或更新版本",
    "config": "默认安装到“应用程序”",
    "version": null,
    "bytes": null,
    "url": null
  }
] as const;

export const preparationSteps=[
  {
    id:'01',
    title:'确认系统与备份',
    text:'核对上方的系统要求，并备份已有配置与重要文件。安装包发布后，再确认来源、系统和架构。',
  },
  {
    id:'02',
    title:'安装与连接',
    text:'获取正式安装包后，按对应系统指引安装；启动助手后连接账户，再完成模型配置。',
  },
  {
    id:'03',
    title:'开始第一个任务',
    text:'从一个简单任务开始，确认连接与模型可用，再按需要选择 Skills。',
  },
] as const;
